module.exports = __webpack_public_path__ + "static/img/Crystals.ca062cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Crystals.png
// module id = 9tys
// module chunks = 1